import styled from 'styled-components'

export const FooterStyled = styled.footer`
  margin-top: 30px;
  .footer-text {
    text-align: center;
  }
`
